module.exports = __webpack_public_path__ + "static/img/ent-99.77383ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-99.jpg
// module id = X1/0
// module chunks = 52